import React, { useEffect, useRef, useState } from 'react'
import InputField from '../../jsx/components/fields/inputField';
import TextArea from '../../jsx/components/fields/textArea';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import imageCompression from 'browser-image-compression';
import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import { sendPushNotificationApi } from '../../service/api/messaging/sendPushNotification';
import ImagePreviewer from '../../jsx/components/imagePreviewer/imagePreviewer';
import SelectPeriodFilter from '../../jsx/components/fields/selectPeriodFilter';
import { sendEmailApi } from '../../service/api/messaging/sendEmail';
import { sendTextMessageApi } from '../../service/api/messaging/sendTextMessage';
import TextEditor from '../../component/textEditor/textEditor';

const SendNotificationsByAdmin = () => {
  const dispatch = useDispatch();
  const [attachedImage0, setAttachedImage0] = useState(null);
  const [notificationTitle, setNotificationTitle] = useState(``);
  const [notificationDescription, setNotificationDescription] = useState(``);

  const [notificationTitleErr, setNotificationTitleErr] = useState(false);
  const [notificationDescriptionErr, setNotificationDescriptionErr] = useState(false);

  const [sendNotificationLoading, setSendNotificationLoading] = useState(false);

  const [responseMsg, setResponseMsg] = useState("");
  const [toasterType, setToasterType] = useState('');
  const [handleToaster, setHandleToaster] = useState(false);

  const [openDoc, setOpenDoc] = React.useState(false);
  const [imageAttachURL, setImageAttachURL] = useState('');
  const [notesMessage, setNotesMessage] = useState("");

  const [isMounted, setIsMounted] = useState(true);

  const [userRoleFilter, setUserRoleFilter] = useState('0');
  const userRoleArr = [
    { id: "0", name: "All" },
    { id: "1", name: "Professional" },
    { id: "2", name: "Customer" },
    { id: "3", name: "Super admin" },
    { id: "4", name: "Company admin" },
  ]

  const [sendNotificationsNav, setSendNotificationsNav] = useState(1);

  const handleOpenDoc = () => {
    setOpenDoc(true);
  }
  const handleCloseDoc = () => {
    setOpenDoc(false);
    setNotesMessage('');
  }

  const handleChangeNotificationTitle = (e) => {
    setNotificationTitleErr(false);
    setNotificationTitle(e?.target?.value);
  };

  const handleChangeNotificationTitleBlurCheck = () => {
    if (notificationTitle === ``) {
      setNotificationTitleErr(true);
    }
  }

  const handleChangeNotificationDescription = (e) => {
    setNotificationDescriptionErr(false);
    setNotificationDescription(e?.target?.value);
  };

  const handleChangeNotificationDescriptionBlurCheck = () => {
    if (notificationDescription === ``) {
      setNotificationDescriptionErr(true);
    }
  }

  // Attachment Upload 1
  const attachedImage0Ref = useRef();
  const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
  const [uploadImgLoading, setUploadImgLoading] = useState(false);


  const handleClickAttachedImage0 = () => {
    attachedImage0Ref.current.click();
  }
  async function handleAttachedImage0(e) {
    if (e.target.files) {
      // setUploadAttachedImage0(e.target.files[0]);
      // setAttachedImage0(URL.createObjectURL(e.target.files[0]))

      const file = e.target.files[0];

      if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
        setUploadImgLoading(true);
        try {
          const options = {
            maxSizeMB: 0.5, // Maximum size in MB
            maxWidthOrHeight: 1920, // Maximum width or height
            useWebWorker: true, // Use web worker for faster compression
          };
          const compressedFile = await imageCompression(file, options);
          // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
          // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
          // setSelectedFile(compressedFile);
          setUploadAttachedImage0(compressedFile);
          setAttachedImage0(URL.createObjectURL(compressedFile));
          setUploadImgLoading(false);
        } catch (error) {
          // console.error('Error compressing the image:', error);
          setUploadImgLoading(false);
        }
      } else {
        setUploadAttachedImage0(file);
        setAttachedImage0(URL.createObjectURL(file));
      }
    }
  }

  function deleteAttachedImage0() {
    setUploadAttachedImage0(null);
    setAttachedImage0(null)
  }


  const handleSendNotification = (e) => {
    // e.preventDefault();

    if (notificationTitle === '') {
      setNotificationTitleErr(true);
    }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }



    if (notificationTitle !== '' && notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();


      formData.append("title", notificationTitle);
      formData.append("body", notificationDescription);
      // formData.append("user_id", ``);
      userRoleFilter && formData.append("role_id", userRoleFilter);
      (uploadAttachedImage0 != null) && formData.append("image", uploadAttachedImage0);

      dispatch(sendPushNotificationApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResponseMsg(res.data.message)
        setToasterType("success")

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResponseMsg(err.data.message)
        setToasterType("error")

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }




  }

  const handleSendEmailNotification = (e) => {
    // e.preventDefault();

    if (notificationTitle === '') {
      setNotificationTitleErr(true);
    }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }

    if (notificationTitle !== '' && notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();

      formData.append("subject", notificationTitle);
      formData.append("body", notificationDescription);
      // formData.append("user_id", ``);
      userRoleFilter && formData.append("role_id", userRoleFilter);
      (uploadAttachedImage0 != null) && formData.append("attachment", uploadAttachedImage0);

      dispatch(sendEmailApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResponseMsg(res.data.message);
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResponseMsg(err.data.message);
        setToasterType("error");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }
  }

  const handleSendTextMessageNotification = (e) => {
    // e.preventDefault();

    // if (notificationTitle === '') {
    //   setNotificationTitleErr(true);
    // }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }

    if (notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();

      // formData.append("subject", notificationTitle);
      formData.append("body", notificationDescription);
      // formData.append("user_id", ``);
      userRoleFilter && formData.append("role_id", userRoleFilter);
      // (uploadAttachedImage0 != null) && formData.append("image", uploadAttachedImage0);

      dispatch(sendTextMessageApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResponseMsg(res.data.message);
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResponseMsg(err.data.message);
        setToasterType("error");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }
  }

  const handleClearSendNotification = () => {
    setAttachedImage0(null);
    setNotificationTitle(``);
    setNotificationDescription(``);
    setUploadAttachedImage0(null);
    setUserRoleFilter('0');

    setIsMounted(false);
    setTimeout(() => setIsMounted(true), 0);
  }

  const handleUserRoleFilter = (e) => {
    setUserRoleFilter(e.target.value);
  }

  useEffect(() => {
    setAttachedImage0(null);
    setNotificationTitle(``);
    setNotificationDescription(``);
    setNotificationTitleErr(false);
    setNotificationDescriptionErr(false);
  }, [sendNotificationsNav]);

  return (
    <>
      <div
        className='row mx-0'
        style={{ minHeight: '80dvh' }}
      >

        <div className='col-md-3'></div>


        <div className='col-md-6 d-flex justify-content-center align-items-center p-3'>
          <div className='row mx-0 w-100'>
            <div className='col-12 d-flex justify-content-center align-items-center flex-column'>


              <div className='w-100'>

                <div className='d-flex justify-content-center mb-4'>
                  <span className='text-black font-w600 fs-3 text-center'>{`Send Notifications`}</span>
                </div>

                {/* Navigations Bar */}
                <div
                  className='border-bottom mb-4 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                >
                  <div className='col-12 d-flex px-0 fs-5 font-w500'>
                    <div
                      onClick={() => {
                        setSendNotificationsNav(1)
                      }}
                      className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                      style={{}}
                    >
                      <span className={`${sendNotificationsNav === 1 ? "text-black" : "text-grey"} ${sendNotificationsNav === 1 && "fw-bold"}`} >{"Push Notifications"}</span>
                      {sendNotificationsNav === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                    </div>

                    <div
                      onClick={() => {
                        setSendNotificationsNav(2)
                      }}
                      className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                      style={{}}
                    >
                      <span className={`${sendNotificationsNav === 2 ? "text-black" : "text-grey"} ${sendNotificationsNav === 2 && "fw-bold"}`}>{"Email"}</span>
                      {sendNotificationsNav === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                    </div>

                    <div
                      onClick={() => {
                        setSendNotificationsNav(3)
                      }}
                      className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                      style={{}}
                    >
                      <span className={`${sendNotificationsNav === 3 ? "text-black" : "text-grey"} ${sendNotificationsNav === 3 && "fw-bold"}`}>{`SMS`}</span>
                      {sendNotificationsNav === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                    </div>
                  </div>
                </div>

                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (sendNotificationsNav === 1) {
                      handleSendNotification()
                    } else if (sendNotificationsNav === 2) {
                      handleSendEmailNotification()
                    } else if (sendNotificationsNav === 3) {
                      handleSendTextMessageNotification()
                    }
                  }}
                >
                  {sendNotificationsNav !== 3 &&
                    <div className='row mx-0 mb-4'>
                      <div className='col-12 p-1 d-flex justify-content-between align-items-center border rounded-2 '>
                        <div className='ps-3'>
                          <span className='fs-6 font-w600 '>{`Add ${sendNotificationsNav === 1 ? 'picture to your notification' : 'attachment to email'}`}</span>
                        </div>


                        <div className='d-flex overflow-auto'>
                          {attachedImage0 == null &&
                            <div
                              className='rounded-2 d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn'
                              style={{
                                border: '2px solid orange',
                                height: '65px',
                                width: '100px',
                                backgroundColor: "rgb(215 225 243)",
                                opacity: uploadImgLoading ? '0.5' : '1',
                                pointerEvents: uploadImgLoading ? 'none' : 'auto',
                              }}
                              onClick={handleClickAttachedImage0}
                            >
                              {uploadImgLoading ?
                                <>
                                  <Spinner animation="border" size="sm" variant="primary" />
                                </> :
                                <>
                                  <span>
                                    <i className="bi bi-plus-lg fs-4"></i>
                                  </span>
                                  <span className='font-w600 fs-7'>
                                    {`Add ${sendNotificationsNav === 1 ? 'photo' : 'attachment'}`}
                                  </span>
                                </>}
                              <input ref={attachedImage0Ref} type="file" accept={`image/*, ${sendNotificationsNav === 2 ? 'application/pdf' : ''}`} hidden onChange={(e) => { handleAttachedImage0(e) }} />
                            </div>
                          }

                          {attachedImage0 !== null &&
                            <div
                              className='rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn shadow me-1'
                              style={{ border: '2px solid orange', height: '65px', width: '100px', backgroundColor: "rgb(215 225 243)", }}
                              onClick={() => {
                                handleOpenDoc();
                                setImageAttachURL(attachedImage0);
                              }}
                            >
                              <span
                                className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center'
                                style={{ top: '3px', right: '3px', border: '1px solid red', width: '25px', height: '25px', zIndex: '2' }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e?.stopPropagation();
                                  deleteAttachedImage0()
                                }}
                              >
                                <i className="bi bi-x-lg"></i>
                              </span>
                              <img src={attachedImage0} className='rounded-2 documents-individual-box-img' alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>}
                        </div>


                      </div>

                    </div>}

                  <div className='mx-0 row'>
                    <div className='col-12 px-0'>
                      {isMounted && <SelectPeriodFilter
                        labelName={`Send to`}
                        onChange={(e) => handleUserRoleFilter(e)}
                        defaultValue={userRoleFilter}
                        options={userRoleArr}
                        errorOccured={false}
                        errorMessage={""}
                      />}
                    </div>
                  </div>

                  {sendNotificationsNav !== 3 &&
                    <div className='mx-0 row mb-2'>
                      <div className='col-12 px-0'>
                        <InputField
                          labelName={"Title"}
                          placeholder={"Notification title"}
                          value={notificationTitle}
                          onChange={handleChangeNotificationTitle}
                          onBlur={handleChangeNotificationTitleBlurCheck}
                          errorOccured={notificationTitleErr}
                          errorMeesage={"Please enter notification title"}
                          isRequired={true}
                        />
                      </div>
                    </div>
                  }

                  <div className='mx-0 row mb-2'>
                    <div className='col-12 px-0'>
                      {(sendNotificationsNav == 1 || sendNotificationsNav == 3) &&
                        <TextArea
                          labelName={`Description (text or talk) *`}
                          placeholder={`Provide us detail to your project and we can automatically provide you a step by step plan.`}
                          value={notificationDescription}
                          onChange={handleChangeNotificationDescription}
                          onBlur={handleChangeNotificationDescriptionBlurCheck}
                          errorOccured={notificationDescriptionErr}
                          errorMessage={"Enter notification description"}
                          // autoActivated={true}
                          // isPlaceholder={true}
                          rows={'7'}
                        />
                      }

                      {(sendNotificationsNav == 2) &&
                        <TextEditor content={notificationDescription} setContent={setNotificationDescription} />
                      }
                    </div>
                  </div>


                  {sendNotificationsNav === 3 &&
                    <div className='row mb-3'>
                      <div className='col-12 px-0 fs-6 font-w600 text-danger'>
                        <span className=''>
                          <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        </span>
                        <span className=''>{`Note : Bulk SMS can be sent only after the Twilio messaging campaign has been approved. `}</span>
                      </div>

                    </div>
                  }

                  <div className='row mx-0'>
                    <div
                      className='col-12 px-0 my-4'
                      style={{
                        pointerEvents: sendNotificationsNav === 3 ? "none" : "auto",
                        opacity: sendNotificationsNav === 3 ? "0.5" : "1",
                      }}
                    >
                      <PrimaryButton
                        buttonName={`SEND`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (sendNotificationsNav === 1) {
                            handleSendNotification()
                          } else if (sendNotificationsNav === 2) {
                            handleSendEmailNotification()
                          }
                        }}
                        isLoading={sendNotificationLoading}
                        loadingMessage={"SENDING..."}
                        style={{
                          width: '100%',
                          background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                          border: '2px solid rgba(255, 154, 32, 1)',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-3'></div>

      </div>

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responseMsg} />}

      {/* Modal for previewing the attached image preview */}
      {openDoc &&
        <ImagePreviewer
          openDoc={openDoc}
          handleCloseDoc={handleCloseDoc}
          imageAttachURL={imageAttachURL}

        // notesMessage={discussionVal}
        // isNoteEdit={isNoteEdit}
        // onClick={handleUpdateProjectNotes}
        // buttonLoading={saveLoading}
        // setDiscussionVal={setDiscussionVal}
        />
      }

    </>
  )
}

export default SendNotificationsByAdmin;